"use client";

import { Checkbox } from "@/components/ui/checkbox";
import {
  setUmrahFilters,
  useUmrahFilter,
} from "@/feature/umrah/package/search/state/extract-umrah-filter-slice";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { UmrahAccordion } from "./umrah-accordion";

function getGroupSizeLabel(value: string) {
  if (value === "1-2") return "1-2 Pilgrims";
  if (value === "3-5") return "3-5 Pilgrims";
  if (value === "6-10") return "6-10 Pilgrims";
  return "11+ Pilgrims";
}

export function UmrahGroupSizeFilter() {
  const dispatch = useAppDispatch();
  const { selectedOption, defaultOption } = useAppSelector(useUmrahFilter);
  const options = defaultOption.groupSizes;

  if (!options.length) {
    return null;
  }

  return (
    <UmrahAccordion value="group_size" label="Group Size">
      <div className="space-y-2">
        {options.map((size) => (
          <label
            key={size}
            className="flex items-center gap-2 text-sm text-muted-foreground"
          >
            <Checkbox
              checked={selectedOption.groupSizes.includes(size)}
              onCheckedChange={(checked) => {
                if (checked === "indeterminate") return;

                const next = selectedOption.groupSizes.includes(size)
                  ? selectedOption.groupSizes.filter((item) => item !== size)
                  : [...selectedOption.groupSizes, size];
                dispatch(setUmrahFilters({ groupSizes: next }));
              }}
            />
            <span>{getGroupSizeLabel(size)}</span>
          </label>
        ))}
      </div>
    </UmrahAccordion>
  );
}
